// hardcoded review data that will come from Review service
export const reviewData: {
  [key: number]: { numOfReviews: number; rating: number };
} = {
  55: {
    numOfReviews: 4552,
    rating: 4.7,
  },
  79: {
    numOfReviews: 7,
    rating: 4.8,
  },
  76: {
    numOfReviews: 66,
    rating: 4.82,
  },
  83: {
    numOfReviews: 296,
    rating: 4.81,
  },
};
